function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__a",
  x1: "87.464%",
  x2: "-20.776%",
  y1: "18.887%",
  y2: "60.52%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E4E8F2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__d",
  x1: "86.615%",
  x2: "128.27%",
  y1: "49.973%",
  y2: "49.973%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#C9D2DF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#CAD3E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__e",
  x1: "86.618%",
  x2: "128.26%",
  y1: "49.906%",
  y2: "49.906%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E8ECF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#CAD3E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__f",
  x1: "-168.86%",
  x2: "156.384%",
  y1: "50.024%",
  y2: "50.024%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E9F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__g",
  x1: "3.567%",
  x2: "106.521%",
  y1: "50.584%",
  y2: "50.584%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E8ECF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#CAD3E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__j",
  x1: "50.881%",
  x2: "45.581%",
  y1: "88.559%",
  y2: "-4.082%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__k",
  x1: "-.005%",
  x2: "100.689%",
  y1: "49.721%",
  y2: "49.721%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: "99.94%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__l",
  x1: ".129%",
  x2: "281.962%",
  y1: "49.637%",
  y2: "49.637%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#CAD3E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#E8ECF2"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__m",
  x1: "42.442%",
  x2: "42.442%",
  y1: "-12.766%",
  y2: "115.294%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__n",
  x1: "50.014%",
  x2: "50.014%",
  y1: "1.294%",
  y2: "187.055%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "37.78%",
  stopColor: "#F0F2F8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "99.97%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__o",
  x1: "4.329%",
  x2: "114.347%",
  y1: "49.714%",
  y2: "49.714%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E4E8F2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "37.78%",
  stopColor: "#F0F2F8"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "99.97%",
  stopColor: "#FFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__p",
  x1: ".57%",
  x2: "100.055%",
  y1: "49.225%",
  y2: "49.225%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#D95576"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FF8787"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__q",
  x1: "-.181%",
  x2: "100.119%",
  y1: "49.695%",
  y2: "49.695%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E8ECF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#CAD3E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__r",
  x1: "-8.24%",
  x2: "110.635%",
  y1: "29.703%",
  y2: "69.007%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0.4
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__s",
  x1: "-.181%",
  x2: "100.119%",
  y1: "49.774%",
  y2: "49.774%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E8ECF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#CAD3E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__t",
  x1: "-8.24%",
  x2: "110.635%",
  y1: "29.761%",
  y2: "69.065%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0.4
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__u",
  x1: "-.181%",
  x2: "100.119%",
  y1: "50.016%",
  y2: "50.016%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#E8ECF2"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#CAD3E0"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__v",
  x1: "-8.24%",
  x2: "110.635%",
  y1: "29.523%",
  y2: "68.827%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0.4
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__w",
  x1: "-95.632%",
  x2: "565.671%",
  y1: "32.876%",
  y2: "110.9%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__x",
  x1: "-60.04%",
  x2: "108.969%",
  y1: "46.432%",
  y2: "51.925%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__y",
  x1: "-73.451%",
  x2: "402.267%",
  y1: "39.55%",
  y2: "79.941%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__z",
  x1: "-176.855%",
  x2: "235.256%",
  y1: "33.31%",
  y2: "63.625%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__A",
  x1: "-230.943%",
  x2: "375.184%",
  y1: "19.524%",
  y2: "85.078%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__B",
  x1: "-109.251%",
  x2: "550.937%",
  y1: "31.269%",
  y2: "109.03%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__C",
  x1: "50.671%",
  x2: "-20.71%",
  y1: "56.265%",
  y2: "178.103%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "12%",
  stopColor: "#495161"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "54%",
  stopColor: "#7A89A1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "84%",
  stopColor: "#98ADCA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A3BAD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__D",
  x1: "28.827%",
  x2: "137.838%",
  y1: "29.451%",
  y2: "123.489%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "12%",
  stopColor: "#495161"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "54%",
  stopColor: "#7A89A1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "84%",
  stopColor: "#98ADCA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A3BAD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__E",
  x1: "79.424%",
  x2: "24.688%",
  y1: "88.393%",
  y2: "-7.019%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "12%",
  stopColor: "#495161"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "54%",
  stopColor: "#7A89A1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "84%",
  stopColor: "#98ADCA"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A3BAD9"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__F",
  x1: "82.054%",
  x2: "-8.123%",
  y1: "46.315%",
  y2: "54.533%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3A3F4C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__G",
  x1: "756.41%",
  x2: "256.148%",
  y1: "-23.183%",
  y2: "30.302%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: "53%",
  stopColor: "#3A3F4C",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3A3F4C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__H",
  x1: "871.316%",
  x2: "220.394%",
  y1: "-48.206%",
  y2: "29.276%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: "53%",
  stopColor: "#3A3F4C",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3A3F4C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__I",
  x1: "419.998%",
  x2: "70.036%",
  y1: "11.542%",
  y2: "47.106%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: "53%",
  stopColor: "#3A3F4C",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3A3F4C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__J",
  x1: "38.471%",
  x2: "56.842%",
  y1: "126.205%",
  y2: "27.668%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3A3F4C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "customer-trust_svg__K",
  x1: "205.148%",
  x2: "122.923%",
  y1: "-27.01%",
  y2: "13.717%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#3A3F4C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#3A3F4C",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "customer-trust_svg__h",
  cx: "49.998%",
  cy: "49.822%",
  r: "49.915%",
  fx: "49.998%",
  fy: "49.822%",
  gradientTransform: "scale(.9986 1)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "customer-trust_svg__i",
  cx: "49.911%",
  cy: "49.822%",
  r: "49.915%",
  fx: "49.911%",
  fy: "49.822%",
  gradientTransform: "scale(.9986 1)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C386"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C386",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("filter", {
  id: "customer-trust_svg__b",
  width: "125.1%",
  height: "654.5%",
  x: "-12.6%",
  y: "-313.6%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: -4,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 9.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0.533333333 0 0 0 0 0.6 0 0 0 0 0.682352941 0 0 0 0.669908217 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "customer-trust_svg__c",
  d: "M26.98 242H264c3.973 0 3.973 11 0 11H26.98c-3.973 0-3.973-11 0-11z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__a)",
  d: "M92.562 291.436c70.802 30.02 183.334-66.204 225.147 103.248 18.145 73.533 121.809 7.45 158.14-61.099 68.909-130.02-41.919-230.443-132.897-194.875-69.961 28.981-141.689 52.2-120.879-2.3 16.137-42.26-54.95-70.012-94.13-26.403-18.61 20.7-129.097 141.693-35.38 181.429z",
  transform: "rotate(150 265.77 192.91)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(3 -1)"
}, /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  opacity: 0.8,
  transform: "matrix(1 0 0 -1 0 495)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#customer-trust_svg__b)",
  xlinkHref: "#customer-trust_svg__c"
}), /*#__PURE__*/React.createElement("use", {
  fill: "url(#customer-trust_svg__d)",
  xlinkHref: "#customer-trust_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#748DAD",
  strokeLinecap: "round",
  strokeWidth: 5,
  d: "M21 216.29H0",
  opacity: 0.75
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__e)",
  d: "M6.109.11h249.199a5.27 5.27 0 015.276 5.267v48.246a5.27 5.27 0 01-5.276 5.268H6.108a5.27 5.27 0 01-5.275-5.268V5.377A5.27 5.27 0 016.109.11z",
  opacity: 0.8,
  transform: "translate(15 187.79)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__f)",
  d: "M5.97.11h214.77c2.776 0 5.136 2.356 5.136 5.129v48.384c0 2.772-2.36 5.13-5.137 5.13H5.97c-2.776 0-5.136-2.358-5.136-5.13V5.239c0-2.912 2.36-5.13 5.137-5.13z",
  transform: "translate(15 187.79)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#748DAD",
  d: "M61.23 207.032h153.407c2.5 0 4.582 2.08 4.582 4.575v10.536c0 2.496-2.083 4.575-4.582 4.575H61.23c-2.499 0-4.581-2.08-4.581-4.575v-10.398c0-2.634 2.082-4.713 4.581-4.713z",
  opacity: 0.75
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__g)",
  d: "M23.323.832h134.943c2.499 0 4.443 1.94 4.443 4.436v10.814c0 2.495-1.944 4.436-4.443 4.436H23.323c-2.499 0-4.442-1.94-4.442-4.436V5.268c0-2.357 1.943-4.436 4.442-4.436z",
  opacity: 0.8,
  transform: "translate(56.649 206.2)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(21.553 210.358)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.774,
  cy: 6.655,
  fill: "url(#customer-trust_svg__h)",
  rx: 6.664,
  ry: 6.655
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 6.774,
  cy: 6.655,
  fill: "#23C386",
  rx: 3.887,
  ry: 3.882
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(37.213 210.358)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.358,
  cy: 6.655,
  fill: "url(#customer-trust_svg__i)",
  rx: 6.664,
  ry: 6.655
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 7.358,
  cy: 6.655,
  fill: "#23C386",
  rx: 3.887,
  ry: 3.882
}))), /*#__PURE__*/React.createElement("path", {
  stroke: "#9FEED0",
  d: "M127.5 59.79v-31"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#23C386",
  d: "M119.168 4.209l-8.497 14.5c-2.507 4.281.697 9.667 5.711 9.667h16.993c5.014 0 8.218-5.386 5.71-9.667l-8.496-14.5c-2.646-4.28-8.914-4.28-11.421 0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__j)",
  d: "M17.271 3.419l-8.496 14.5c-2.507 4.281.696 9.667 5.71 9.667H31.48c5.014 0 8.217-5.386 5.71-9.667l-8.496-14.5C27.439 1.209 25.21.243 22.983.243h-7.244s2.229 1.933 1.532 3.176z",
  transform: "translate(109 .79)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M126.411 18.709h-3.343l-.696-11.462h4.875zm.836 5.524l-4.875-.138v-2.9l4.875.138z",
  fill: "#FFF"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#customer-trust_svg__k)",
  strokeWidth: 2.496,
  d: "M44 143.563c22.671 0 17.525 22.738 44.368 18.578 29.208-4.436 25.453-101.35 39.64-101.35 17.385 0 9.597 100.796 48.262 100.796 21.837 0 17.386-10.26 37.414-10.26C235.8 151.327 260 187.79 260 187.79"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 258,
  cy: 216.791,
  fill: "url(#customer-trust_svg__l)",
  fillRule: "nonzero",
  opacity: 0.8,
  rx: 5,
  ry: 7
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#748DAD",
  strokeLinecap: "round",
  strokeWidth: 5,
  d: "M259 216.79h67.281c14.813 0 26.719-11.953 26.719-26.827v-40.172",
  opacity: 0.75
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__m)",
  fillRule: "nonzero",
  d: "M44 143.563c22.671 0 17.525 22.738 44.368 18.578 29.208-4.436 25.453-101.35 39.64-101.35 17.385 0 9.597 100.796 48.262 100.796 21.837 0 17.386-10.26 37.414-10.26C235.8 151.327 260 187.79 260 187.79H44v-44.228z"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  transform: "translate(254 46.79)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__n)",
  d: "M194.702.255H29.42c-4.718 0-8.465 4.324-8.465 9.763v140.869c0 3.347 2.776 6.137 6.106 6.137h170c3.33 0 6.106-2.79 6.106-6.137V10.018c0-5.44-3.747-9.763-8.465-9.763z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M174.302.255H9.02C4.302.255.555 4.58.555 10.018v140.869c0 3.347 2.776 6.137 6.106 6.137h169.861c3.331 0 6.107-2.79 6.107-6.137V10.018c.138-5.44-3.747-9.763-8.327-9.763z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__o)",
  d: "M174.302.255H9.02C4.302.255.555 4.58.555 10.018v11.437H182.63V10.018c.138-5.44-3.747-9.763-8.327-9.763z"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 11.241,
  cy: 10.855,
  fill: "url(#customer-trust_svg__p)",
  rx: 3.886,
  ry: 3.905
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 22.898,
  cy: 10.855,
  fill: "#EAC13D",
  rx: 3.886,
  ry: 3.905
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 34.416,
  cy: 10.855,
  fill: "#23C386",
  rx: 3.886,
  ry: 3.905
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__q)",
  fillRule: "nonzero",
  d: "M.387 12.575V25.71c0 1.676 1.388 3.074 3.053 3.074h13.04c5.133 0 9.157-4.192 9.157-9.222V6.427c0-1.676-1.388-3.074-3.052-3.074H9.544C4.411 3.213.25 7.405.387 12.575z",
  opacity: 0.8,
  transform: "translate(271 80.79)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#customer-trust_svg__r)",
  strokeWidth: 3.652,
  d: "M6.492 10.759l7.631 8.663L31.187.699",
  transform: "translate(271 80.79)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__s)",
  fillRule: "nonzero",
  d: "M.387 12.134v13.134c0 1.677 1.388 3.074 3.053 3.074h13.04c5.133 0 9.157-4.191 9.157-9.221V5.986c0-1.676-1.388-3.074-3.052-3.074H9.544C4.411 2.772.25 6.964.387 12.134z",
  opacity: 0.8,
  transform: "translate(271 116.722)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#customer-trust_svg__t)",
  strokeWidth: 3.652,
  d: "M6.492 10.318l7.631 8.663L31.187.258",
  transform: "translate(271 116.722)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__u)",
  fillRule: "nonzero",
  d: "M.387 12.296V25.43c0 1.677 1.388 3.074 3.053 3.074h13.04c5.133 0 9.157-4.192 9.157-9.222V6.148c0-1.677-1.388-3.074-3.052-3.074H9.544C4.411 3.074.25 7.266.387 12.296z",
  opacity: 0.8,
  transform: "translate(271 153.448)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#customer-trust_svg__v)",
  strokeWidth: 3.652,
  d: "M6.492 10.619l7.631 8.663L31.187.559",
  transform: "translate(271 153.448)"
}), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__w)",
  d: "M.139 1.816V5.03c0 .699.832 1.537 1.526 1.537l19.285-.14c.277 0 .555-.14.555-.559V2.655c0-.699-.833-1.537-1.527-1.537l-19.284.14c-.417 0-.555.279-.555.558z",
  transform: "translate(308.847 96.16)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__x)",
  d: "M32.742 6.288l81.44-.56c.277 0 .555-.139.555-.558V1.956c0-.698-.832-1.537-1.526-1.537L31.77.98c-.277 0-.555.139-.555.558v3.214c.139.838.833 1.537 1.526 1.537z",
  transform: "translate(308.847 96.16)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__y)",
  d: "M.139 38.425v3.213c0 .699.832 1.537 1.526 1.537l27.609-.14c.277 0 .555-.14.555-.558v-3.214c0-.699-.833-1.537-1.526-1.537l-27.61.14c-.416.14-.554.28-.554.559z",
  transform: "translate(308.847 96.16)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__z)",
  d: "M39.818 38.285v3.214c0 .698.832 1.537 1.526 1.537l32.188-.14c.277 0 .554-.14.554-.559v-3.214c0-.698-.832-1.537-1.526-1.537l-32.326.14c-.277 0-.416.14-.416.559z",
  transform: "translate(308.847 96.16)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__A)",
  d: "M54.663 76.57v-3.214c0-.698-.832-1.537-1.526-1.537l-21.227.14c-.278 0-.555.14-.555.559v3.214c0 .698.832 1.536 1.526 1.536l21.227-.14c.278-.139.555-.279.555-.558z",
  transform: "translate(308.847 96.16)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__B)",
  d: "M.277 72.658v3.213c0 .699.833 1.537 1.527 1.537l19.284-.14c.278 0 .555-.14.555-.558v-3.214c0-.699-.832-1.537-1.526-1.537l-19.285.14c-.416 0-.693.14-.555.559z",
  transform: "translate(308.847 96.16)"
})), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__C)",
  d: "M51.78 41.335l-.7 37.175-18.62-15.397L31.34 47.3z",
  transform: "translate(203 109.79)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__D)",
  d: "M32.46 46.468c14.7-2.774 13.72 22.055 13.72 22.055s7.42-11.93 13.16-13.178c4.76-.97 9.24 4.023 10.64 6.797.14.416 0 .832-.28.97-.14.14-.28.14-.42 0-1.26-.415-2.8-.415-4.06-.277 1.68 1.388 2.8 3.19 3.22 5.271 0 .417-.28.694-.56.694-.14 0-.28 0-.42-.139-1.4-.693-2.94-1.11-4.62-.97.56 1.941.56 4.022.14 5.964-.14.416-.56.555-.98.416-.14 0-.28-.139-.42-.277a15.283 15.283 0 00-5.04-4.855s-2.66 17.755-9.8 16.784c-7-.833-28.98-36.481-14.28-39.255z",
  transform: "translate(203 109.79)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__E)",
  d: "M.82 23.997a.429.429 0 01.56 0c5.18 1.526 10.64 1.664 15.82.555 1.26-.278 2.66-.417 4.06-.417.98.14 1.96.555 2.8 1.11 1.96-4.993 6.44-8.6 13.3-10.82l1.4-.415c6.86-2.22 12.6-1.804 17.08.97.28-.97.84-1.803 1.54-2.496 1.12-.832 2.24-1.526 3.5-2.08 4.9-2.081 9.24-5.41 12.46-9.572.14-.138.28-.277.56-.416.56-.139 1.12.139 1.4.694v.416c0 .416-.14 2.22-.14 2.774-.14 2.22-1.68 7.49-.56 12.761 0 .555.14 1.11.28 1.665l-2.8 1.387 2.94.97c0 2.22-.56 4.44-1.68 6.382l-3.92-.694 2.24 2.635a11.242 11.242 0 01-5.74 2.497c.7.971 1.12 2.22 1.4 3.33.42 1.802 0 3.606-1.12 5.132-1.4 2.219-4.06 4.16-8.26 6.241-.7.555-1.12 1.249-1.26 2.081 0 1.248-1.96 2.497-5.88 3.745h-.14c-1.68.555-3.5.971-5.32.971-.7 0-1.26-.138-1.68-.693-.56-.694-1.4-.971-2.24-.971-4.76.693-8.4.555-10.78-.416-1.68-.694-3.08-2.081-3.64-3.884V47.3c-.28-.971-.56-2.08-.56-3.052-.7.417-1.54.694-2.38.833l-.56-3.19-1.26 3.328-.84-1.664-.84 1.803c-1.96-.139-3.92-.97-5.46-2.22l2.52-4.022-4.06 2.497c-1.12-1.11-1.96-2.22-2.66-3.607l1.68-1.525-2.38.416 2.38-2.358-3.08.97c-2.38-4.16-6.02-6.935-7.28-8.46-.28-.417-1.54-1.804-1.82-2.081-.14-.139-.14-.278-.28-.416-.14.277.14-.278.7-.555z",
  transform: "translate(203 109.79)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__F)",
  d: "M13.98 29.823c4.48.416 8.26.97 9.8 3.467 1.68 2.497 1.96 6.797 2.24 10.404 0 .416.14.832.14 1.248-.7.416-1.54.693-2.24.97l-.56-3.19-1.26 3.33-.84-1.665-.84 1.803c-1.96-.138-3.92-.97-5.46-2.219l2.52-4.023-4.06 2.497c-1.12-1.11-1.96-2.22-2.66-3.606l1.68-1.526-2.38.416 2.38-2.358-3.08.97c-2.38-4.16-6.02-6.935-7.28-8.46C1.8 27.465.54 26.077.26 25.8c4.62 3.329 9.24 3.745 13.72 4.023z",
  transform: "translate(203 109.79)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__G)",
  d: "M37.36 18.171c-1.12.139-2.1.416-3.08.97-.56.278-.84.833-.42.972.98.277 1.96.139 2.8-.416 1.12-.555 1.26-1.249.7-1.526z",
  transform: "translate(203 109.79)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__H)",
  d: "M36.24 20.806c-1.4.555-.14 1.665.7 1.526.84-.138 2.1-.97 1.68-1.387-.28-.555-1.68-.416-2.38-.139z",
  transform: "translate(203 109.79)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__I)",
  d: "M41.84 16.506c-.98.278-1.68 1.249-1.96 2.22 0 .555.84.555 2.66.277 1.82-.277 3.22-1.664 3.08-2.08-.14-.555-2.8-.694-3.78-.417z",
  transform: "translate(203 109.79)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__J)",
  d: "M60.74 21.639c.14-1.665.14-4.023 4.2-7.213h.14c1.68-1.11 3.36-2.497 4.76-4.023 2.38-2.497 4.2-5.41 5.6-8.6 0 .416-.14 2.22-.14 2.774-.14 2.22-1.68 7.49-.56 12.762 0 .555.14 1.11.28 1.664l-2.8 1.387 2.94.971c0 2.22-.56 4.439-1.68 6.38l-3.92-.693 2.24 2.636c-1.54 1.387-3.64 2.22-5.74 2.497-.28-.416-.42-.694-.7-.971-2.24-2.636-4.9-6.658-4.62-9.571z",
  transform: "translate(203 109.79)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#customer-trust_svg__K)",
  d: "M32.88 42.029c.7 1.526 2.1 2.08 5.04 1.11.42-.139.7-.278 1.12-.416 3.08-1.249 4.34-2.081 7.84-3.33 3.5-1.11 5.04-1.11 8.26-1.941.42-.14.84-.14 1.12-.278 2.94-.97 3.78-2.22 3.36-3.884 3.08 1.11.98 4.994-1.12 6.936-2.66 2.358-5.74 4.161-9.1 5.132l-.98.277c-3.36 1.11-6.86 1.665-10.36 1.249-2.8-.278-7-2.08-5.18-4.855z",
  transform: "translate(203 109.79)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M262.48 147.796c.56-.832 1.26-2.219.7-3.329h-.14v.14a3.443 3.443 0 01-1.96 2.218v.14l1.4.831zm-1.26 1.665c.28-.416.7-.694.98-1.11v-.138l-1.4-.971h-.14l.42 2.08c0 .139.14.139.14 0v.139zm-.84.277l-.42-2.219c0-.139-.14-.139-.28-.139l-.42.139c-.42.139-.84.277-1.26.277h-.14c-.14 0-.14.14-.14.278 0 0 0 .139.14.139l2.52 1.525zm-3.22 2.636c.98-.416 1.82-.971 2.66-1.665.14-.138.14-.277 0-.416l-2.66-1.942h-.14l-.14 3.745c0 .14.14.278.28.278zm-.98.277l.14-4.022c0-.139-.14-.278-.28-.278h-.14l-1.12.278-2.1.416c-.14 0-.14.139-.14.277 0 0 0 .139.14.139l3.5 3.19c0 .139 0 .139 0 0 0 .139 0 .139 0 0zm-3.64 1.804c.98-.278 1.82-.694 2.66-1.11.14-.139.28-.278.14-.416v-.139l-2.94-2.774.14 4.439zm-.28-4.44v4.162c0 .139.14.278.28.278h.14l-.42-4.44zm-.84 4.44c0 .138.14.138 0 0 .14 0 .14 0 0 0l.14-4.717c0-.138-.14-.277-.28-.277h-.14c-.42 0-.84.277-1.26.416l-1.26.416c-.14 0-.28.278-.14.416v.14l2.94 3.606zm-3.5 1.387c.84-.14 1.82-.417 2.8-.694.14 0 .28-.139.14-.416v-.139l-2.52-3.329h-.14l-.7 4.023c0 .277.14.416.42.555-.14 0 0 0 0 0zm-1.12-.14l.84-4.715c0-.139 0-.278-.14-.278h-.14c-.7.278-1.4.555-1.96.833l-1.12.554c-.14 0-.14.14-.14.278l2.66 3.329c0 .139 0 .139 0 0zm-4.2.694c.98 0 2.1 0 3.08-.138.14 0 .28-.139.28-.278v-.138l-2.38-2.913h-.14l-.98 3.051c-.14.139 0 .278.14.416zm-2.1-2.496l1.12 2.08h.14l.84-2.635c0-.139 0-.278-.14-.278h-.28c-.42.14-.7.278-1.12.417l-.42.138c-.14 0-.14.139-.14.278zm-1.12 1.942c.42.138.98.277 1.4.416.14 0 .14 0 .14-.139l-.98-1.942h-.14l-.42 1.665c-.14-.14-.14 0 0 0zm-1.26-.555c.14.138.42.138.56.277l-.56-.277zm.56.277l.42-1.387v-.139c-.56.14-1.12 0-1.82-.138-.42-.139-.84-.278-1.12-.555h-.14c0 .139 0 .277.14.416.42.694 1.12 1.248 1.96 1.526l.56.277z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3A3F4C",
  d: "M260.38 133.093c-2.38.694-4.34 4.3-8.26 7.49-1.4 1.11-2.94 2.22-3.22 2.359.98-.14 1.82-.278 2.8-.555 1.54 1.387 3.64 1.803 5.6.97 2.52-.554 4.2-3.05 3.78-5.548l-.42-1.664c-1.4.416-2.8.97-4.06 1.803a15.256 15.256 0 014.06-3.19 7.994 7.994 0 012.52-.416s-1.12-1.804-2.52-1.387l-.28.138zm-28.7 11.236c1.68-.278 3.5-.278 5.18.138-1.54.14-3.08.417-4.48.971.14.555.42 1.11.7 1.665 1.12 2.22 3.92 3.19 6.3 2.22 1.96-.556 3.5-2.081 3.92-4.162.84-.277 1.68-.694 2.52-1.11-.28 0-2.24.139-4.06 0-5.04-.277-8.82-1.942-11.06-1.11-1.4.555-1.12 2.636-1.12 2.636.42-.555 1.26-.97 2.1-1.248z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3EB883",
  d: "M236.86 144.467c-1.54.14-2.94.417-4.48.971.14.555.42 1.11.7 1.665 1.12 2.22 3.92 3.19 6.3 2.22 1.96-.556 3.5-2.081 3.92-4.162-2.24 0-4.34-.277-6.44-.694zm14.84-2.08c1.54 1.387 3.64 1.664 5.6.97 2.52-.554 4.06-3.05 3.64-5.548l-.42-1.664c-1.4.416-2.8.97-4.06 1.803-1.54 1.665-3.08 3.19-4.76 4.439z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#8FE6C1",
  d: "M253.66 142.387c-.42-.832 3.92-3.607 3.92-3.607 1.26-1.11 1.54 0 1.4.555-.14.555-.42 2.636-1.82 3.33-1.12.554-2.38.415-3.5-.278zm-18.48 4.855c.84.97 2.1 1.525 3.5 1.525 1.54-.138 2.8-1.387 2.8-2.358 0-.97-5.32-.554-5.32-.554-.84.138-1.96.416-.98 1.387z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M255.2 140.722s-1.4.971-1.26 1.665c.14.693 1.96-1.526 2.52-1.942.56-.416-.14-.555-1.26.277zm-15.96 5.271s1.68-.138 1.96.555c.28.694-2.52 0-3.22-.139-.7 0-.14-.416 1.26-.416z"
}))));

function SvgCustomerTrust(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 461 319"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/customer-trust.50fd337b.svg";
export { SvgCustomerTrust as ReactComponent };